module.exports = __webpack_public_path__ + "img/pr-5.2d2f23e9.png";